import MuiDialogActions from '@mui/material/DialogActions';

import { styled } from 'helpers';

import { Props } from './types';

export const DialogActions = styled(MuiDialogActions)<Props>`
  padding: 0 32px;
`;

export default DialogActions;
